import { Col, Row } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxSpin } from 'components/RevxSpin';
import { EqptFilterObj } from 'domains/eqptDomain';
import {
  buildCreatePaperMarkupParam,
  buildCreateParcelMarkupParam,
  buildCreatePressMarkupParam,
  buildCreateShippingMarkupParam,
  buildCreateSvcMarkupParam,
  buildCreateSvcmatMarkupParam,
  ElementTypeEnum,
  PartialMarkup,
} from 'domains/markupDomain';
import { MatFilterObj } from 'domains/matDomain';
import { ParcelFilterObj } from 'domains/parcelDomain';
import { SvcFilter } from 'domains/svcDomain';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { FILTER_NOT_EXISTS } from 'utils/constants';
import ElementMarkupCard, { ElementMarkupCardProps } from './ElementMarkupCard';

const ElementTab = () => {
  const dispatch = useAppDispatch();
  const saving = useAppSelector(
    (state) => state.loading.effects.markup.saveMarkup
  );
  const industryAvgPaper = useAppSelector(
    (state) => state.industryAvg.elementMarkupPaper
  );
  const industryAvgPress = useAppSelector(
    (state) => state.industryAvg.elementMarkupPress
  );
  const industryAvgSvc = useAppSelector(
    (state) => state.industryAvg.elementMarkupSvc
  );
  const industryAvgSvcmat = useAppSelector(
    (state) => state.industryAvg.elementMarkupSvcmat
  );
  const industryAvgParcel = useAppSelector(
    (state) => state.industryAvg.elementMarkupParcel
  );
  const industryAvgShipping = useAppSelector(
    (state) => state.industryAvg.elementMarkupShipping
  );

  useEffect(() => {
    dispatch.markup.getElementMarkups();
    dispatch.mat.getNoMarkupCount();
    dispatch.eqpt.getNoMarkupCount();
    dispatch.svc.getAllSVCs();
    dispatch.parcel.getNoMarkupCount();
  }, [
    dispatch.markup,
    dispatch.mat,
    dispatch.eqpt,
    dispatch.svc,
    dispatch.parcel,
  ]);
  const history = useHistory();

  const paperMarkupPropsBase: ElementMarkupCardProps = {
    markup: 10,
    industryAvg: industryAvgPaper,
    onSave: (v: number | null) => {},
    title: 'platform.markup.labels.paperTitle',
    noMarkupCount: 30,
    noMarkupLabel: 'platform.markup.labels.paperNoMarkup',
    onJump: () => {
      const filterObj: MatFilterObj = {
        markupPct: FILTER_NOT_EXISTS,
      };
      dispatch.mat.setFilter(filterObj);
      history.push('/platform/material');
    },
    allMarkupLabel: 'platform.markup.labels.paperAllMarkup',
  };
  const paperProps = useAppSelector((state) => {
    const noMarkupCount = state.mat.noMarkupCount;
    const paperMarkup = state.markup.elementMarkups.find(
      (m) => m.elementType === ElementTypeEnum.PAPER
    );
    if (paperMarkup === undefined) {
      return {
        ...paperMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          dispatch.markup.saveMarkup(buildCreatePaperMarkupParam(m));
        },
      };
    } else if (paperMarkup.markupRanges[0].markupPct === null) {
      return {
        ...paperMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...paperMarkup,
            markupRanges: [
              {
                ...paperMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    } else {
      return {
        ...paperMarkupPropsBase,
        markup: paperMarkup.markupRanges[0].markupPct,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...paperMarkup,
            markupRanges: [
              {
                ...paperMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    }
  });

  const pressMarkupPropsBase: ElementMarkupCardProps = {
    markup: 10,
    industryAvg: industryAvgPress,
    onSave: (v: number | null) => {},
    title: 'platform.markup.labels.pressTitle',
    noMarkupCount: 30,
    noMarkupLabel: 'platform.markup.labels.pressNoMarkup',
    onJump: () => {
      const filterObj: EqptFilterObj = {
        markupPct: FILTER_NOT_EXISTS,
      };
      dispatch.eqpt.setFilter(filterObj);
      history.push('/platform/eqpt');
    },
    allMarkupLabel: 'platform.markup.labels.pressAllMarkup',
  };
  const pressProps = useAppSelector((state) => {
    const noMarkupCount = state.eqpt.noMarkupCount;
    const pressMarkup = state.markup.elementMarkups.find(
      (m) => m.elementType === ElementTypeEnum.PRESS
    );
    if (pressMarkup === undefined) {
      return {
        ...pressMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          dispatch.markup.saveMarkup(buildCreatePressMarkupParam(m));
        },
      };
    } else if (pressMarkup.markupRanges[0].markupPct === null) {
      return {
        ...pressMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...pressMarkup,
            markupRanges: [
              {
                ...pressMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    } else {
      return {
        ...pressMarkupPropsBase,
        markup: pressMarkup.markupRanges[0].markupPct,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...pressMarkup,
            markupRanges: [
              {
                ...pressMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    }
  });

  const svcMarkupPropsBase: ElementMarkupCardProps = {
    markup: 10,
    industryAvg: industryAvgSvc,
    onSave: (v: number | null) => {},
    title: 'platform.markup.labels.svcTitle',
    noMarkupCount: 30,
    noMarkupLabel: 'platform.markup.labels.svcNoMarkup',
    onJump: () => {
      const filter: SvcFilter = {
        markupPct: FILTER_NOT_EXISTS,
      };
      dispatch.svc.setFilter(filter);
      history.push('/platform/svc');
    },
    allMarkupLabel: 'platform.markup.labels.svcAllMarkup',
  };
  const svcProps = useAppSelector((state) => {
    const noMarkupCount = state.svc.noMarkupCountSvc;
    const svcMarkup = state.markup.elementMarkups.find(
      (m) => m.elementType === ElementTypeEnum.SVC
    );
    if (svcMarkup === undefined) {
      return {
        ...svcMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          dispatch.markup.saveMarkup(buildCreateSvcMarkupParam(m));
        },
      };
    } else if (svcMarkup.markupRanges[0].markupPct === null) {
      return {
        ...svcMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...svcMarkup,
            markupRanges: [
              {
                ...svcMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    } else {
      return {
        ...svcMarkupPropsBase,
        markup: svcMarkup.markupRanges[0].markupPct,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...svcMarkup,
            markupRanges: [
              {
                ...svcMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    }
  });

  const svcmatMarkupPropsBase: ElementMarkupCardProps = {
    markup: 10,
    industryAvg: industryAvgSvcmat,
    onSave: (v: number | null) => {},
    title: 'platform.markup.labels.svcmatTitle',
    noMarkupCount: 30,
    noMarkupLabel: 'platform.markup.labels.svcmatNoMarkup',
    onJump: () => {
      const filter: SvcFilter = {
        materialMarkupPct: FILTER_NOT_EXISTS,
      };
      dispatch.svc.setFilter(filter);

      history.push('/platform/svc');
    },
    allMarkupLabel: 'platform.markup.labels.svcmatAllMarkup',
  };
  const svcmatProps = useAppSelector((state) => {
    const noMarkupCount = state.svc.noMarkupCountSvcmat;
    const svcmatMarkup = state.markup.elementMarkups.find(
      (m) => m.elementType === ElementTypeEnum.SVC_MATERIAL
    );
    if (svcmatMarkup === undefined) {
      return {
        ...svcmatMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          dispatch.markup.saveMarkup(buildCreateSvcmatMarkupParam(m));
        },
      };
    } else if (svcmatMarkup.markupRanges[0].markupPct === null) {
      return {
        ...svcmatMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...svcmatMarkup,
            markupRanges: [
              {
                ...svcmatMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    } else {
      return {
        ...svcmatMarkupPropsBase,
        markup: svcmatMarkup.markupRanges[0].markupPct,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...svcmatMarkup,
            markupRanges: [
              {
                ...svcmatMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    }
  });

  const parcelMarkupPropsBase: ElementMarkupCardProps = {
    markup: 10,
    industryAvg: industryAvgParcel,
    onSave: (v: number | null) => {},
    title: 'platform.markup.labels.parcelTitle',
    noMarkupCount: 30,
    noMarkupLabel: 'platform.markup.labels.parcelNoMarkup',
    onJump: () => {
      const filterObj: ParcelFilterObj = {
        markupPct: FILTER_NOT_EXISTS,
      };
      dispatch.parcel.setFilter(filterObj);
      history.push('/platform/parcel');
    },
    allMarkupLabel: 'platform.markup.labels.parcelAllMarkup',
  };
  const parcelProps = useAppSelector((state) => {
    const noMarkupCount = state.parcel.noMarkupCount;
    const parcelMarkup = state.markup.elementMarkups.find(
      (m) => m.elementType === ElementTypeEnum.PARCEL
    );
    if (parcelMarkup === undefined) {
      return {
        ...parcelMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          dispatch.markup.saveMarkup(buildCreateParcelMarkupParam(m));
        },
      };
    } else if (parcelMarkup.markupRanges[0].markupPct === null) {
      return {
        ...parcelMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...parcelMarkup,
            markupRanges: [
              {
                ...parcelMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    } else {
      return {
        ...parcelMarkupPropsBase,
        markup: parcelMarkup.markupRanges[0].markupPct,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...parcelMarkup,
            markupRanges: [
              {
                ...parcelMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    }
  });

  const shippingMarkupPropsBase: ElementMarkupCardProps = {
    markup: 10,
    industryAvg: industryAvgShipping,
    onSave: (v: number | null) => {},
    title: 'platform.markup.labels.shippingTitle',
    noMarkupCount: 30,
    noMarkupLabel: 'platform.markup.labels.shippingNoMarkup',
    onJump: () => {
      history.push('/platform/shipping');
    },
    allMarkupLabel: 'platform.markup.labels.shippingAllMarkup',
  };
  const shippingProps = useAppSelector((state) => {
    const noMarkupCount = state.shipping.noMarkupCount;
    const shippingMarkup = state.markup.elementMarkups.find(
      (m) => m.elementType === ElementTypeEnum.SHIPPING
    );
    if (shippingMarkup === undefined) {
      return {
        ...shippingMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          dispatch.markup.saveMarkup(buildCreateShippingMarkupParam(m));
        },
      };
    } else if (shippingMarkup.markupRanges[0].markupPct === null) {
      return {
        ...shippingMarkupPropsBase,
        markup: null,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...shippingMarkup,
            markupRanges: [
              {
                ...shippingMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    } else {
      return {
        ...shippingMarkupPropsBase,
        markup: shippingMarkup.markupRanges[0].markupPct,
        noMarkupCount,
        onSave: (m: number | null) => {
          const updateParam: PartialMarkup = {
            ...shippingMarkup,
            markupRanges: [
              {
                ...shippingMarkup.markupRanges[0],
                markupPct: m,
              },
            ],
          };
          dispatch.markup.saveMarkup(updateParam);
        },
      };
    }
  });

  return (
    <RevxSpin spinning={saving}>
      <Row gutter={[16, 16]}>
        <Col span={10}>
          <ElementMarkupCard key="paper" {...paperProps} />
        </Col>
        <Col span={10}>
          <ElementMarkupCard key="press" {...pressProps} />
        </Col>
        <Col span={4} />
        <Col span={10}>
          <ElementMarkupCard key="svc" {...svcProps} />
        </Col>
        <Col span={10}>
          <ElementMarkupCard key="svcmat" {...svcmatProps} />
        </Col>
        <Col span={4} />
        <Col span={10}>
          <ElementMarkupCard key="parcel" {...parcelProps} />
        </Col>
        <Col span={10}>
          <ElementMarkupCard key="shipping" {...shippingProps} />
        </Col>
      </Row>
    </RevxSpin>
  );
};

export default ElementTab;
